import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core'

import { SectionContentSplit } from 'app/core/cms/generated/api-types'
import { PictureComponent } from 'app/shared/picture/picture.component'
import { baseContainerMd } from 'app/static/style-vars.const'

import { CmsBlock } from '../../cms-block'
import { ContainerInfo } from '../../container-info'
import { InsertDynamicContentDirective } from '../../insert-dynamic-content.directive'
import { LayoutContainer } from '../layout-container'
import { parseDesign } from '../section-utils'

@Component({
  selector: 'pai-section-content-split',
  templateUrl: './section-content-split.component.html',
  styleUrls: ['./section-content-split.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.background]': 'design().background',
    '[attr.layout]': 'data().imagePosition',
  },
  imports: [PictureComponent, InsertDynamicContentDirective],
  providers: [
    { provide: CmsBlock, useExisting: SectionContentSplitComponent },
    { provide: LayoutContainer, useExisting: SectionContentSplitComponent },
  ],
})
export class SectionContentSplitComponent extends CmsBlock<SectionContentSplit> implements LayoutContainer {
  readonly __typename = 'SectionContentSplit'
  protected readonly design = computed(() => parseDesign(this.data().design))

  readonly containerInfo = signal<ContainerInfo>({
    maxWidthAtMd: '50vw', // fixme: but at sm it is 100vw as we no longer have 2 columns
    maxWidthAtLg: `${baseContainerMd / 2}px`,
    maxWidthAtXl: `${baseContainerMd / 2}px`,
  })
}
